// NPM modules
import React from 'react';
import { Router, Route, Redirect, Switch } from 'react-router-dom';
import browserHistory from './shared/providers/History';
import './App.module.scss';
import './bootstrap-custom.css';
// import './custom-css.scss';
import '@frontend/core/lib/index.css';
import '../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'bootstrap/dist/css/bootstrap.css';
import '../../node_modules/react-loading-skeleton/dist/skeleton.css';
// import './react-draft-wysiwyg.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'rc-time-picker/assets/index.css';
import 'react-image-gallery/styles/css/image-gallery.css';
// Constants file
import Constants from './shared/constants/AppConstants';
import PathConstants from './shared/constants/PathConstants';
// Components file
import Loader from './components/Loader/Loader.lazy';
// Pages file
import Login from './pages/Login/Login.lazy';
import CatalogueHome from './pages/CatalogueHome/CatalogueHome.lazy';
import DashboardHome from './pages/DashboardHome/DashboardHome.lazy';
import FeedbackHome from './pages/FeedbackHome/FeedbackHome.lazy';
import NotificationHome from './pages/NotificationHome/NotificationHome.lazy';
import OrderHome from './pages/OrderHome/OrderHome.lazy';
import VehicleTypeHome from './pages/VehicleTypeHome/VehicleTypeHome.lazy';
import EditUserProfile from './pages/Settings/EditUserProfile/EditUserProfile.lazy';
import SignOut from './pages/Settings/SignOut/SignOut.lazy';
import AppVersionsHome from './pages/Settings/AppVersions/AppVersions.lazy';
import UserHome from './pages/UserHome/UserHome.lazy';
import BookingPage from './pages/BookingPage/BookingPage.lazy';
import { initGA } from '@frontend/core';
// Support modules
import ErrorBoundary from './ErrorBoundary';
import { stripAdminPrefix, withAdminPrefix } from './shared/providers/Utils';

function ProtectedRoute({ component: Component, ...rest }) {
  const isAuthenticated = localStorage.getItem(Constants.FIELD.IS_AUTHENTICATED);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated) {
          return <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: `${PathConstants.LOGIN}`,
                state: { from: props.location },
              }}
            />
          );
        }
      }}
    />
  );
}

function App() {
  // Инициализируем Google Analytics только если tracking ID указан
  const gaTrackingID = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;
  if (gaTrackingID) {
    initGA(gaTrackingID);
  }
  return (
    <Router history={browserHistory}>
      <React.Suspense fallback={<Loader />}>
        <ErrorBoundary>
          <Switch>
            <Route path="/booking" render={(props) => <BookingPage {...props} />} />
            <Route
              exact
              path={PathConstants.ADMIN_BASE}
              render={() => {
                const isAuthenticated = localStorage.getItem(Constants.FIELD.IS_AUTHENTICATED);
                return <Redirect to={isAuthenticated ? PathConstants.HOME : PathConstants.LOGIN} />;
              }}
            />
            <Route path={PathConstants.LOGIN} render={(props) => <Login {...props} />} />
            <Route exact path="/" render={() => <Redirect to={PathConstants.ADMIN_BASE} />} />
            <Route path={PathConstants.ERROR} />
            <ProtectedRoute path={PathConstants.HOME} key={PathConstants.HOME} component={DashboardHome} />

            <Route
              path={PathConstants.ADMIN_BASE}
              render={(props) => (
                <DashboardHome {...props}>
                  <Switch>
                    <Route path="/" exact component={DashboardHome} />
                    <Route
                      path={PathConstants.SETTINGS_EDIT_PROFILE}
                      key={window.location.pathname}
                      component={EditUserProfile}
                    />
                    <Route path={PathConstants.SETTINGS_SIGNOUT} key={window.location.pathname} component={SignOut} />
                    <Route path={PathConstants.SETTINGS_APP_VERSIONS} key={window.location.pathname} component={AppVersionsHome} />
                    {/* Роуты для orders с поддержкой подпутей - должны быть до динамического роутинга */}
                    <Route
                      path={`${PathConstants.ORDERS}/:subPath?`}
                      render={(props) => <OrderHome {...props} />}
                    />
                    <Route path={PathConstants.ORDERS} key={window.location.pathname} component={OrderHome} />
                    {/* Роуты для users с поддержкой подпутей - должны быть до динамического роутинга */}
                    <Route
                      path={`${PathConstants.USERS}/:subPath?`}
                      render={(props) => <UserHome {...props} />}
                    />
                    <Route path={PathConstants.USERS} key={window.location.pathname} component={UserHome} />
                    {/* Остальные статические роуты */}
                    <Route path={PathConstants.CATALOGUES} key={window.location.pathname} component={CatalogueHome} />
                    <Route path={PathConstants.FEEDBACKS} key={window.location.pathname} component={FeedbackHome} />
                    <Route
                      path={PathConstants.NOTIFICATIONS}
                      key={window.location.pathname}
                      component={NotificationHome}
                    />
                    <Route path={PathConstants.VEHICLE_TYPES} key={window.location.pathname} component={VehicleTypeHome} />
                    {/* Динамический роутинг для всех путей из меню - должен быть последним */}
                    <Route
                      path="*"
                      render={(routeProps) => {
                        const currentPath = routeProps.location.pathname;
                        const normalizedPath = stripAdminPrefix(currentPath);
                        
                        // Сначала проверяем путь напрямую
                        if (normalizedPath.startsWith('/orders')) {
                          return <OrderHome {...routeProps} />;
                        } else if (normalizedPath.startsWith('/users')) {
                          return <UserHome {...routeProps} />;
                        } else if (normalizedPath.startsWith('/catalogues')) {
                          return <CatalogueHome {...routeProps} />;
                        } else if (normalizedPath.startsWith('/feedbacks')) {
                          return <FeedbackHome {...routeProps} />;
                        } else if (normalizedPath.startsWith('/notifications')) {
                          return <NotificationHome {...routeProps} />;
                        } else if (normalizedPath.startsWith('/vehicle-types')) {
                          return <VehicleTypeHome {...routeProps} />;
                        }
                        
                        // Получаем конфигурацию меню
                        const configurations = JSON.parse(localStorage.getItem(Constants.FIELD.DASHBOARD_CONFIGURATIONS) || '{}');
                        
                        // Ищем пункт меню по пути
                        let menuItem = null;
                        if (configurations?.menu) {
                          for (const item of configurations.menu) {
                            if (item.eventKey === normalizedPath) {
                              menuItem = item;
                              break;
                            }
                            if (item.subMenus) {
                              for (const subItem of item.subMenus) {
                                if (subItem.eventKey === normalizedPath) {
                                  menuItem = subItem;
                                  break;
                                }
                              }
                              if (menuItem) break;
                            }
                          }
                        }
                        
                        // Определяем компонент на основе найденного пункта меню
                        if (menuItem) {
                          const path = normalizedPath.toLowerCase();
                          if (path.includes('/users') || path.includes('user') || path.includes('rider') || path.includes('driver')) {
                            return <UserHome {...routeProps} />;
                          } else if (path.includes('/catalogues') || path.includes('catalogue')) {
                            return <CatalogueHome {...routeProps} />;
                          } else if (path.includes('/orders') || path.includes('order')) {
                            return <OrderHome {...routeProps} />;
                          } else if (path.includes('/feedbacks') || path.includes('feedback')) {
                            return <FeedbackHome {...routeProps} />;
                          } else if (path.includes('/notifications') || path.includes('notification')) {
                            return <NotificationHome {...routeProps} />;
                          } else if (path.includes('/vehicle-types') || path.includes('vehicle')) {
                            return <VehicleTypeHome {...routeProps} />;
                          }
                        }
                        
                        // Если не найдено, возвращаем DashboardHome
                        return <DashboardHome {...routeProps} />;
                      }}
                    />
                  </Switch>
                </DashboardHome>
              )}
            />
            <Route
              path="*"
              render={(props) => {
                const { pathname, search, hash } = props.location;
                const targetPathname = withAdminPrefix(pathname);
                return <Redirect to={`${targetPathname}${search || ''}${hash || ''}`} />;
              }}
            />
          </Switch>
        </ErrorBoundary>
      </React.Suspense>
    </Router>
  );
}

export default App;
